"use strict";

import "../../scss/pages/awards-details.scss";
import "bootstrap/js/dist/tab";
import PublicationsTable from "../components/publicationTable";
import FormatString from "../helpers/formatString";
import axios from "axios";
import GlobalError from "../helpers/globalError";
import Highcharts from 'highcharts';

export default class AwardsDetails {
	
	loadAwardsDetails(selectedPublicationType, isTabType = true, year = null) {
		const language = document.querySelector('#dropdownlanguageMenu');
		const currentUrl = window.location.pathname.split('/');
		const publicationTypeClassname = selectedPublicationType === 'broadband' ? 'fixed' : selectedPublicationType;
		const loader = document.querySelector('#loaderDetailsTab');
		loader.classList.remove('d-none');

		const storedYear = sessionStorage.getItem(currentUrl[3]+"-"+selectedPublicationType);
		const effectiveYear = year
			? parseInt(year)
			: parseInt(storedYear ?? this.initialYear ?? currentUrl[4]);

		axios.post(`/${ language.dataset.languageSelected }/index/awards-details-by-filter`,
				{
					countryIsoCode: currentUrl[3],
					year: effectiveYear,
					publicationType: selectedPublicationType,
					isTabType: isTabType,
					locale: language.dataset.languageSelected
				}
			)
			.then((response) => {
				const containerAwardsRating = document.querySelector('.container-rating-year .tab-content');
				if (containerAwardsRating) {
					containerAwardsRating.innerHTML = response.data;
				}

				if (isTabType) {
					const containerTab = document.querySelector('#containerTabType');
					if (containerTab) {
						containerTab.innerHTML = response.data;
						const buttonYearSelected = document.querySelector('.container-tab-subparent .btn-year.active');
						const buttonYearList = document.querySelectorAll('.container-tab-subparent .btn-year');
						const sessionYear = sessionStorage.getItem(currentUrl[3]+"-"+selectedPublicationType);

						if (!buttonYearSelected) {
							const fallbackYear = sessionYear ?? [...buttonYearList][0]?.dataset.year;

							// only fall back to a different year, otherwise the same
							// request would be fired over and over
							if (fallbackYear && parseInt(fallbackYear) !== effectiveYear) {
								this.updateAwardsDetailsUrl({
									year: fallbackYear,
								});
								this.loadAwardsDetails(selectedPublicationType, true, fallbackYear);
							}

						} else {
								this.updateAwardsDetailsUrl({
									networkType: selectedPublicationType,
									year: String(effectiveYear),
								});
						}

						document.querySelectorAll('a.btn-year').forEach((button) => {
							button.addEventListener('shown.bs.tab', (event) => {
								sessionStorage.setItem(currentUrl[3]+"-"+selectedPublicationType, event.target.dataset.year);
								this.loadAwardsDetails(event.target.dataset.type === 'fixed' ? 'broadband' : event.target.dataset.type, true, event.target.dataset.year);
								const newAwardsDetailsUrl = {
									year: event.target.dataset.year,
								}
								this.updateAwardsDetailsUrl(newAwardsDetailsUrl);
								const slider = document.querySelector('.container-tab-subparent');
								const containerSlider = document.querySelector('.container-tab-parent');
								const buttonYearList = document.querySelectorAll(`#ratingYear${ FormatString.capitalize(event.target.dataset.type) } .btn-year`);
								const boundingXMin = 0;
								const boundingXMax = slider.scrollWidth - containerSlider.getBoundingClientRect().width;

								buttonYearList.forEach((buttonYear, buttonIndex) => {
									if (event.target.dataset.year === buttonYear.dataset.year) {
										if (buttonIndex < 3) {
											containerSlider.scrollLeft = boundingXMin;
										} else if (buttonIndex === 3) {
											containerSlider.scrollLeft = boundingXMax;
										}
									} else {
										buttonYear.classList.remove('active');
									}
								});
							});
						});
						
						const publicationsTableModule = new PublicationsTable();
						const containerFilter = document.querySelector(`.filterContainer${ FormatString.capitalize(publicationTypeClassname) }`);
						publicationsTableModule.refreshPublicationsTable(true, `#loaderTab${ FormatString.capitalize(publicationTypeClassname) }`, `#tableContainerTab${ FormatString.capitalize(publicationTypeClassname) }`, containerFilter);
					}
				}

				const allGraphs = document.querySelectorAll('div[data-isps]');
				allGraphs.forEach((graph) => {
					this.loadAwardGraph(graph.id);
				})
			})
			.catch((error) => {
				if (error?.response?.data?.errors) {
					loader.classList.add('d-none');
					GlobalError.openErrorModal(error.response.data.errors.message, 'globalAwardsDetails');
				}

				if (error?.response?.status === 404 && isTabType) {
					const buttonTab = document.querySelector(`#tab${ FormatString.capitalize(publicationTypeClassname) }`);
					const lastPublicationYear = buttonTab?.dataset.lastPublication;

					// no publication for the requested year: switch once to the latest
					// available publication, never back to the year that just failed
					if (lastPublicationYear && parseInt(lastPublicationYear) !== effectiveYear) {
						sessionStorage.setItem(currentUrl[3]+"-"+selectedPublicationType, lastPublicationYear);
						this.updateAwardsDetailsUrl({
							year: lastPublicationYear,
						});
						this.loadAwardsDetails(selectedPublicationType, true, lastPublicationYear);
					}
				}
			})
			.finally(function () {
				loader.classList.add('d-none');
			});
	}
	
	/**
	 * Update parameters on awards details url
	 * @param newUrl - Object - parameters url
	 */
	updateAwardsDetailsUrl = (newUrl) => {
		const locale = newUrl.locale ? newUrl.locale : window.location.pathname.split('/')[1];
		const countryCode = newUrl.countryCode ? newUrl.countryCode : window.location.pathname.split('/')[3];
		const year = newUrl.year ? newUrl.year : window.location.pathname.split('/')[4];
		const countryFrFullName = newUrl.countryFrName ? newUrl.countryFrName : window.location.pathname.split('/')[6];
		const networkType = newUrl.networkType ? newUrl.networkType : window.location.pathname.split('/')[5];
		
		const url = `/${ locale }/awards/${ countryCode }/${ year }/${ networkType }/${ countryFrFullName }`;
		history.replaceState({nPerf: 'awardsDetails'}, '', url);
	}

	loadAwardGraph(chartId) {
		const chart = document.querySelector(`#${chartId}`);
		const unit = chart.dataset.unit;
		const isps = JSON.parse(chart.dataset.isps);
		const months = JSON.parse(chart.dataset.months);

		const series = Object.entries(isps).map(([key, item]) => {
			return {
				name: key,
				color: item.color,
				data: item.values,
				lineWidth: 2,
			};
		});

		const maxValue = Math.max(...series.flatMap(s => s.data));

		Highcharts.chart(chartId, {
			chart: {
				type: 'spline'
			},
			title: {
				text: '',
			},
			yAxis: {
				labels: {
					enabled: false,
				},
				title: {
					text: ''
				},
				ceiling: maxValue,
			},
			xAxis: {
				categories: months,
			},
			series,
			tooltip: {
				pointFormat: `{point.y} ${unit}`
			},
			credits: {
				enabled: false
			},
		});
	}
}

document.addEventListener("DOMContentLoaded", function () {
	const awardsDetailsModule = new AwardsDetails();
	const activeTab = document.querySelector('a.tab-network-type.active');
	const containerRankingTableList = document.querySelectorAll('.table-responsive');
	const buttonAwardDownloadList = document.querySelectorAll('.awardsDetails-page .btn-barometer');

	buttonAwardDownloadList.forEach((buttonAwardDownload) => {
		buttonAwardDownload.addEventListener('click', () => {
			/* eslint-disable */
			_paq.push(['trackEvent', 'publicationDetails', buttonAwardDownload.dataset.tag]);
			/* eslint-enable */
		})
	});
	awardsDetailsModule.initialYear = window.location.pathname.split('/')[4];
	awardsDetailsModule.loadAwardsDetails(activeTab.dataset.networkType);
	document.querySelectorAll('a.tab-network-type').forEach((element) => {
		element.addEventListener('shown.bs.tab', function (event) {
			awardsDetailsModule.loadAwardsDetails(
				event.target.dataset.networkType === 'fixed' ? 'broadband' : event.target.dataset.networkType
			);
		});
	});

	containerRankingTableList.forEach((containerRankingTable) => {
		const containerTable = containerRankingTable.closest('.container-table');

		containerRankingTable.addEventListener('scroll', () => {
			const bodyRTL = document.querySelector('body[dir="rtl"]');
			if (bodyRTL) {
				if (containerRankingTable.scrollLeft >= 1) {
					containerTable.classList.remove('scroll-table-right');
				} else if ((containerRankingTable.scrollLeft - containerRankingTable.getBoundingClientRect().width) === -(containerRankingTable.querySelector('.table').scrollWidth - 1)) {
					containerTable.classList.remove('scroll-table-left');
				} else {
					containerTable.classList.add('scroll-table-right', 'scroll-table-left');
				}
			} else {
				if (containerRankingTable.scrollLeft === 0) {
					containerTable.classList.remove('scroll-table-left');
				} else if ((containerRankingTable.scrollLeft + containerRankingTable.getBoundingClientRect().width) === containerRankingTable.querySelector('.table').scrollWidth) {
					containerTable.classList.remove('scroll-table-right');
				} else {
					containerTable.classList.add('scroll-table-right', 'scroll-table-left');
				}
			}

		})
	})
});
